const initialState = {
  clients: [],
  isLoading: null,
  isError: null,
};

export default initialState;
